import { Skeleton } from "@/components/ui/skeleton";

export const HeroSkeleton = () => {
  return (
    <div className="container flex flex-col justify-center gap-12">
      <div className="flex w-full max-w-[1098px] flex-col gap-4 lg:gap-6">
        {/* Price line skeleton */}
        <Skeleton className="h-8 w-48 rounded-md lg:w-64" />

        {/* Main heading skeleton */}
        <div className="flex flex-col gap-4">
          <Skeleton className="h-12 w-full rounded-md lg:h-24" />
          <Skeleton className="h-12 w-3/4 rounded-md lg:h-24" />
        </div>

        {/* Subheading skeleton */}
        <Skeleton className="h-6 w-full rounded-md lg:h-12 lg:w-4/5" />
      </div>

      {/* Button skeleton */}
      <Skeleton className="h-14 w-full rounded-full lg:w-64" />
    </div>
  );
};
